import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Col,
  Container,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Form,
  Row,
  UncontrolledDropdown,
  DropdownItem,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";

//import images

//import Components
import SearchOption from "../Components/Common/SearchOption";

import logo from "../assets/images/Travel/TravelLogo.png";
import { NavLink } from "react-router-dom";
import MultiLevelDropdown from "./Component/MultiLevelDropdown";
import TravelLinkService from "../services/TravelLinkService/TravelLinkService";

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);
  const toggleSidebar = () => setSidebarOpen((prevState) => !prevState);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    try {
      const response = await TravelLinkService.getGeneralSetting();
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div >
      <header
        id="page-topbar"
        className={headerClass}
        style={{
          paddingTop: "7px",
          height: "90px",
          backgroundColor: "#FFFFFF",
        }}
      >
        <div className="layout-width">
          <div className="navbar-header d-flex align-items-center justify-content-between p-0 m-0">
            <div className="navbar-brand-box d-flex flex-row gap-lg-4 gap-0 mt-2">
              <NavLink to="/" className="logo d-none d-lg-flex">
                <img
                  src={data?.company_logo_url}
                  style={{ height: "70px", width: "auto" }}
                  alt="Logo"
                />
              </NavLink>
              <NavLink to="/" className="logo d-lg-none d-flex">
                <img
                  src={data?.company_logo_url}
                  style={{ height: "40px", width: "auto" }}
                  alt="Logo"
                />
              </NavLink>
              <NavLink to="/">
                <div className="d-none d-md-flex flex-column justify-content-center align-content-center gap-0 mt-2">
                  <h2
                    className="active-booking fw-bold mb-0 p-0"
                    style={{
                      fontFamily: "'Arial', sans-serif",
                      // fontWeight: "bold",
                      fontSize: "28px",
                      color: "#0E9EDA", // Adjust color to match the image
                    }}
                  >
                    {data?.company_name}
                  </h2>
                  <span
                    className="fw-normal"
                    style={{
                      fontFamily: "'Arial', sans-serif",
                      fontWeight: "400",
                      fontSize: "14px",
                      color: "#5A5A5A", // Adjust color for the tagline
                    }}
                  >
                    {data?.company_tag_line}
                  </span>
                </div>
              </NavLink>
            </div>

            {/* Desktop Navigation */}
            <div className="d-flex flex-column align-items-end p-0">
              <div className="d-flex justify-content-end align-items-end mt-2 p-0">
                <SearchOption />
              </div>
              {/* <SearchOption /> */}
              <div className="d-lg-flex d-none flex-column align-items-end">
                <MultiLevelDropdown />
              </div>
            </div>

            {/* Hamburger Icon for Sidebar on Small Screens */}
            <button
              onClick={toggleSidebar}
              type="button"
              className="btn btn-sm px-4 d-lg-none header-item vertical-menu-btn topnav-hamburger"
              id="topnav-hamburger-icon"
            >
              <span className="hamburger-icon">
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
          </div>
        </div>
      </header>

      {/* Sidebar for Small Screens */}
      <Offcanvas
        isOpen={sidebarOpen}
        toggle={toggleSidebar}
        className="offcanvas-start"
        fade={false}
      >
        <OffcanvasHeader toggle={toggleSidebar}>
          <NavLink to="/booking" className="logo">
            <img
              src={logo}
              style={{ height: "70px", width: "auto" }}
              alt="Logo"
            />
          </NavLink>
        </OffcanvasHeader>
        <OffcanvasBody>
          <MultiLevelDropdown />
        </OffcanvasBody>
      </Offcanvas>
    </div>
  );
};

export default Header;
